/*
 * Copyright (c) 2021.
 * Rafiq
 */
import Cookies from "universal-cookie";

export default function saveToCookie(key, value) {
  const cookies = new Cookies();
  cookies.set(key, value, {
    path: "/",
    secure: true,
  });
}
